import { atom, useAtom, useSetAtom } from "jotai";

export const defaultPosOrderCustomerPaymentAmount = "";

const customerPaymentAmountAtom = atom<string>(
  defaultPosOrderCustomerPaymentAmount
);

const usePosOrderCustomerPaymentAmount = () => {
  const atom = useAtom(customerPaymentAmountAtom);
  return atom;
};

export const useSetPosOrderCustomerPaymentAmount = () =>
  useSetAtom(customerPaymentAmountAtom);

export default usePosOrderCustomerPaymentAmount;
